export class DistribuidorMantenedorModel {

    idDistribuidor: string;
    nombreDistribuidor: string;
    ruc: string;
    idVendedor: string;
    efectividad: number;
    email: string;
    descripcion?: string;
    telefono: string;
    
    devolverModeloGridMantenedor() {
        const objeto: DistriMantenedorInterface = {
            idDistribuidor: 'idDistribuidor',
            nombreDistribuidor: 'nombreDistribuidor',
            ruc: 'ruc',
            idVendedor: 'idVendedor',
            efectividad: 'efectividad',
            email: 'email',
            descripcion: 'descripcion',
            telefono: 'telefono'
        };
        return objeto;
    }

    constructor() { }
}

export interface DistriMantenedorInterface {
    idDistribuidor: string;
    nombreDistribuidor: string;
    ruc: string;
    idVendedor: string;
    efectividad: string;
    email: string;
    descripcion?: string;
    telefono: string;
}